export default "__VITE_ASSET__DK53x5SF__"